module.exports = __webpack_public_path__ + "static/39-4b53f1df4ef2d1f6f3bb3d4323daf7b3.jpg";